// action types
import { createRequestTypes } from "../../utils";

export const FETCH_MEMBERSHIP_PERIODS = createRequestTypes("FETCH_MEMBERSHIP_PERIODS");

export const fetchMembershipPeriodsRequest = () =>
    ({ type: FETCH_MEMBERSHIP_PERIODS.REQUEST });

export const fetchMembershipPeriodsSuccess = (periods) =>
    ({ type: FETCH_MEMBERSHIP_PERIODS.SUCCESS, payload: { periods } });

export const fetchMembershipPeriodsFailure = (error) =>
    ({ type: FETCH_MEMBERSHIP_PERIODS.FAILURE, payload: { error } });